module.exports = __webpack_public_path__ + "static/media/cellfinate_imagen_cellfinate.f28d6cf7.jpg";